import has from 'lodash.has';
export default {
    methods: {
        getResources (object, groupIdIndex = 0) {
            if (object && (has(object, 'resources') || has(object, 'group_id'))) {
                return has(object, 'resources')
                    ? object.resources
                    : this.$store.getters['sheet/getSheetOneResource'].sheet_resource.find((el) => {
                        return el.id === object.group_id[groupIdIndex];
                    }).resources;
            }
            return [];
        },
        getSheetTwoResources (object, groupIdIndex = 0) {
            if (object && (has(object, 'resources') || has(object, 'group_id'))) {
                return has(object, 'resources')
                    ? object.resources
                    : this.$store.getters['sheet/getSheetTwoResource'].sheet_resource.find((el) => {
                        return el.id === object.group_id[groupIdIndex];
                    }).resources;
            }
            return [];
        }
    }
};
